import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/privacy/page.tsx");
